import { gql } from '@apollo/client';

export const VEHICLE_SEARCH_QUERY = gql`
query VEHICLE_SEARCH_QUERY($perPage: Int, $page: Int, $json: String, $originatorId: ID!) {
  searchVehicles(perPage: $perPage, page: $page, json: $json, originatorId: $originatorId) {
    id
    vehicleMake {
      id
      nhtsaId
      name
    }
    vehicleModel {
      id
      nhtsaId
      name
    }
    vehicleVin {
      id
      name
    }
    vehiclePlate {
      id
      name
    }
    incidents {
      id
      incidentNumber
      personIncidentSpecifics {
        id
        person {
          id
          aliases {
            id
            target {
              id
              validPersonAlerts {
                id
                alertType {
                  id
                  name
                  alertLevel
                }
              }
            }
          }
          validPersonAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
          }
        }
      }
      vehicleIncidentSpecifics {
        id
        vehicle {
          id
        }
      }
    }
    year
  }
}
`;
